import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextButtonCell } from '~/components/common';
import { ManagerNameCellRenderer } from '~/components/vender';

import type { TypeOwnerManagerDetail } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 화주사 정보] '담당자 정보' 테이블
 *
 * 편집 권한이 없으면 선택 칸은 비워 두고 '수정' 컬럼을 빼며, 이메일 컬럼이 남는 너비를 채운다.
 */
const getVenderConfirmManagerInfoColumnDefs = ({
  hasEditPermission,
  onClickManagerModify,
}: {
  hasEditPermission: boolean;
  onClickManagerModify: (data: TypeOwnerManagerDetail) => void;
}) => {
  const baseColumns: TypeTableColumn<TypeOwnerManagerDetail>[] = [
    {
      id: 'selection',
      header: '',
      cell: () => null,
      size: 72,
      meta: { selection: true },
    },
    {
      accessorKey: 'ownerLoginId',
      header: '아이디',
      size: 200,
      cell: ({ getValue, row }) => <ManagerNameCellRenderer value={getValue<string>()} rowIndex={row.index} />,
    },
    {
      accessorKey: 'ownerManagerName',
      header: '담당자명',
      size: 140,
    },
    {
      accessorKey: 'ownerManagerPosition',
      header: '직위',
      size: 120,
    },
    {
      accessorKey: 'ownerManagerTel',
      header: '휴대폰번호',
      size: 140,
    },
    {
      accessorKey: 'ownerManagerEmail',
      header: '이메일',
      size: 288,
      meta: { flex: !hasEditPermission },
    },
  ];

  const modifyColumn: TypeTableColumn<TypeOwnerManagerDetail> = {
    id: 'modify',
    header: '',
    minSize: 107,
    cell: ({ row }) => (
      <TextButtonCell showDashIfNoValue={false} onClick={() => onClickManagerModify(row.original)}>
        수정
      </TextButtonCell>
    ),
    meta: { flex: true },
  };
  const columnDefs = hasEditPermission ? [...baseColumns, modifyColumn] : baseColumns;

  return { columnDefs };
};

export default getVenderConfirmManagerInfoColumnDefs;
